import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createPurchaseRefund } from "api/purchaseRefund.api";
import {
  invalidatePurchaseRefundSide,
  invalidateVendorSide,
} from "lib/cacheInvalidation";

export const useCreatePurchaseRefund = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createPurchaseRefund,
    onSuccess: () => {
      invalidatePurchaseRefundSide(queryClient);
      invalidateVendorSide(queryClient);
    },
  });
};
